import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">Technologies We Use</h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Following are the latest technologies that we utilize in your
              telehealth solutions to ensure the robust development of our
              application:
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frameworks and libraries">
              <ul>
                <li>.NET Core</li>
                <li>ASP.NET</li>
                <li>ASP.NET Core</li>
                <li>Angular</li>
                <li>React</li>
                <li>Ruby on Rails</li>
                <li>Vue.js</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Cloud">
              <ul>
                <li>Microsoft Azure</li>
                <li>Amazon Web Services</li>
                <li>Google Cloud Platform</li>
                <li>Apprenda</li>
                <li>Rackspace</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Database">
              <ul>
                <li>SQL Server</li>
                <li>Postgres</li>
                <li>MongoDB</li>
                <li>Amazon</li>
                <li>DynamoDB</li>
                <li>Azure Cosmos DB</li>
                <li>Redis</li>
                <li>SSIS (Microsoft SQL Server Integration Services)</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Backend">
              <ul>
                <li>Microsoft.Net</li>
                <li>Java</li>
                <li>Python</li>
                <li>Node</li>
                <li>php</li>
                <li>Go</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Frontend">
              <ul>
                <li>HTML</li>
                <li>CSS</li>
                <li>JS</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
